import { useEffect, useState } from 'react';
import useApi from './useApi';

export interface NoteTypeOption {
  key: string;
  value: string;
}

interface NoteTypeResponse {
  msg: string;
  data: NoteTypeOption[];
  status: string;
}

const useNoteTypeOptions = () => {
  const [noteTypeOptions, setNoteTypeOptions] = useState<NoteTypeOption[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  
  const { makeApiCall } = useApi({
    url: '/rtm/note/type-options',
    method: 'GET'
  });

  useEffect(() => {
    const fetchNoteTypeOptions = async () => {
      try {
        const { response, error: apiError } = await makeApiCall<null, NoteTypeResponse>();
        
        if (apiError) {
          setError(apiError.msg || 'Failed to fetch note type options');
          return;
        }
        
        if (response?.data) {
          setNoteTypeOptions(response.data);
        }
      } catch (err) {
        setError('An error occurred while fetching note type options');
        console.error('Error fetching note type options:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchNoteTypeOptions();
  }, [makeApiCall]);

  return { noteTypeOptions, loading, error };
};

export default useNoteTypeOptions;